var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCorner2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 142,
    height: 216,
    viewBox: "0 0 142 216",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M113.246 75.9959C169.867 98.5077 127.776 138.528 100.773 153.593L-0.165024 215.667L-0.165029 153.593L-0.165042 4.36783C10.3518 -1.88543 31.0444 -6.20588 29.68 26.5384C27.9746 67.4688 42.471 47.8563 113.246 75.9959Z",
    fill: "#FF3900"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorner2);
export default __webpack_public_path__ + "static/media/corner2.930423f2ea2e8d312ba3e0a959417d4c.svg";
export { ForwardRef as ReactComponent };